import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Icon,
  Tooltip,
  Select,
  Row,
  Col,
  Button,
  Radio,
  Input,
  InputNumber,
  Table,
  Form,
  Divider,
  notification,
} from 'antd';
import { inject, observer } from 'mobx-react';

const { Option } = Select;
const InputGroup = Input.Group;

@inject('dataStore')
@inject('commonStore')
@observer
class MapMenu extends React.Component {
  static propTypes = {
    commonStore: PropTypes.object.isRequired,
    dataStore: PropTypes.object.isRequired,
  };

  state = {
    customMihPoe: {
      value: null,
    },
  };

  componentWillMount() {
    const { dataStore } = this.props;
    dataStore.setCurrentMaptype('hazard');
  }

  onDatasetChange = value => {
    this.props.dataStore.setCurrentDataset(value);
  };

  onMaptypeChange = e => {
    this.props.dataStore.setCurrentMaptype(e);
  };

  onMihPoeChange = e => {
    this.props.dataStore.setCurrentMihPoe(e);
  };

  onMaptypeChange = e => {
    const maptype = e.target.value;
    this.props.dataStore.setCurrentMaptype(maptype);
    if (maptype === 'hazard') {
      this.props.dataStore.setCurrentMihPoe('2475');
    } else {
      this.props.dataStore.setCurrentMihPoe('1');
    }
  };

  onMihPoeChange = e => {
    const mihPoe = e;
    this.props.dataStore.setCurrentMihPoe(mihPoe);
  };

  onMihPoeEnter = e => {
    if (this.props.dataStore.currentMaptype === 'hazard') {
      if (e.keyCode === 13) {
        if (e.target.value >= 50 && e.target.value <= 10000) {
          const mihPoe = e.target.value;
          this.props.dataStore.setCurrentMihPoe(mihPoe);
        }
      }
    } else if (e.keyCode === 13) {
      if (e.target.value >= 0.05 && e.target.value <= 5) {
        const mihPoe = e.target.value;
        this.props.dataStore.setCurrentMihPoe(mihPoe);
      }
    }
  };

  handleCustomMihPoeChange = value => {
    function validateCustomMihPoe(customMihPoe, currentMapType) {
      if (currentMapType === 'hazard') {
        if (
          (customMihPoe >= 50 && customMihPoe <= 10000) ||
          customMihPoe === '' ||
          typeof customMihPoe === 'undefined'
        ) {
          return {
            validateStatus: 'success',
            errorMsg: null,
          };
        }
        return {
          validateStatus: 'error',
          errorMsg: '*Enter between 50 and 10000!',
        };
      } else if (currentMapType === 'probability') {
        if ((customMihPoe >= 0.05 && customMihPoe <= 5) || customMihPoe === '' || typeof customMihPoe === 'undefined') {
          return {
            validateStatus: 'success',
            errorMsg: null,
          };
        }
        return {
          validateStatus: 'error',
          errorMsg: '*Enter between 0.05 and 5!',
        };
      }
    }
    this.setState({
      customMihPoe: {
        ...validateCustomMihPoe(value, this.props.dataStore.currentMaptype),
        value,
      },
    });
  };

  handleExportCurves = () => {
    notification.warning({
      message: 'Export Curves',
      description: 'Files are being generated, it can take some time. Please wait.',
      duration: 0,
    });
    this.props.dataStore.exportCurves(this.props.dataStore.currentDataset).then(() => {
      notification.destroy();
      notification.success({
        message: 'Export Curves',
        description: 'Curves have been successfully exported!',
      });
    });
  };

  handleExportMapMenuClick = () => {
    notification.warning({
      message: 'Export Maps',
      description: 'Files are being generated, it can take some time. Please wait.',
      duration: 0,
    });
    this.props.dataStore.exportMaps(this.props.dataStore.currentDataset).then(() => {
      notification.destroy();
      notification.success({
        message: 'Export Maps',
        description: 'Maps have been successfully exported!',
      });
    });
  };

  render() {
    const { commonStore, dataStore } = this.props;

    const currentSettingsData = [
      {
        key: '1',
        parameter: 'Map Type',
        value: dataStore.currentMaptype,
      },
      {
        key: '2',
        parameter: dataStore.currentMaptype === 'hazard' ? 'ARP' : 'MTA',
        value: dataStore.currentMihPoe + (dataStore.currentMaptype === 'hazard' ? ' yr' : ' m'),
      },
    ];

    const glossaryData = [
      {
        key: '1',
        parameter: 'MTA',
        value: "Maximum Tsunami Amplitude(m) at 20m water depth",
      },
      {
        key: '2',
        parameter: 'POE',
        value: "Annual Probability of Exceedance",
      },
    ];

    if (commonStore.currentRoute === '/') {
      const { customMihPoe } = this.state;
      return (
        <div>
          <div className="sidebar-menu__parameters">
            {commonStore.token ? (
              <Fragment>
                <h4>
                  Dataset&nbsp;
                  <Tooltip title="Please select the dataset to be loaded.">
                    <Icon type="question-circle-o" />
                  </Tooltip>
                </h4>
                <Row type="flex" justify="center" gutter={5}>
                  {/* <Col>
                    <Select
                      defaultValue="tsumaps-neam"
                      onChange={this.onDatasetChange}
                      style={{
                        width: 330,
                      }}
                    >
                      {dataStore.datasetList.map(d => <Option key={d.id}>{d.name}</Option>)}
                    </Select>
                  </Col> */}
                  <Col>
                    <Link to="/submit-data">
                      <Button type="primary">Submit Data</Button>
                    </Link>
                  </Col>
                </Row>
                <Divider />
              </Fragment>
            ) : null}
            <Radio.Group size="small" defaultValue="hazard" onChange={this.onMaptypeChange} buttonStyle="solid">
              <Radio.Button style={{ width: 165 }} value="hazard">
                Hazard Map
              </Radio.Button>
              <Radio.Button style={{ width: 165 }} value="probability">
                Probability Map
              </Radio.Button>
            </Radio.Group>
            <Divider />
            <div>
              <h4>
                {dataStore.currentMaptype === 'hazard' ? 'MTA for given ARPs' : 'PoE for given MTAs'}&nbsp;
                <Tooltip title="MTA = Maximum Tsunami Amplitude. You can select from pick list, or enter a custom value.">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </h4>
              <Form>
                <InputGroup compact>
                  {dataStore.currentMaptype === 'hazard' ? (
                    <Form.Item style={{ marginBottom: 0 }}>
                      <Select
                        style={{ width: 100 }}
                        size="small"
                        onChange={this.onMihPoeChange}
                        value={this.props.dataStore.currentMihPoe}
                      >
                        <Option value="72">72yr</Option>
                        <Option value="475">475yr</Option>
                        <Option value="2475">2475yr</Option>
                        <Option value="4975">4975yr</Option>
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <Select
                        style={{ width: 100 }}
                        size="small"
                        onChange={this.onMihPoeChange}
                        value={this.props.dataStore.currentMihPoe}
                      >
                        <Option value="0.1">0.1m</Option>
                        <Option value="0.2">0.2m</Option>
                        <Option value="0.5">0.5m</Option>
                        <Option value="1">1m</Option>
                        <Option value="3">3m</Option>
                      </Select>
                    </Form.Item>
                  )}
                  <Form.Item
                    validateStatus={customMihPoe.validateStatus}
                    help={customMihPoe.errorMsg}
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    <InputNumber
                      style={{ width: 220, marginLeft: 10 }}
                      placeholder={
                        dataStore.currentMaptype === 'hazard' ? 'Custom ARP (Press ↵)' : 'Custom MTA (Press ↵)'
                      }
                      size="small"
                      min={dataStore.currentMaptype === 'hazard' ? 50 : 0.05}
                      max={dataStore.currentMaptype === 'hazard' ? 10000 : 5}
                      onChange={this.handleCustomMihPoeChange}
                      onKeyDown={this.onMihPoeEnter}
                    />
                  </Form.Item>
                </InputGroup>
              </Form>
            </div>
          </div>

          <div className="sidebar-menu__currentsettings">
            <Table
              style={{
                backgroundColor: 'var(--primary-color)',
              }}
              size="small"
              title={() => (
                <span
                  style={{
                    border: '0',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  Active Map Summary
                </span>
              )}
              pagination={false}
              columns={[
                {
                  title: 'Parameter',
                  dataIndex: 'parameter',
                  key: 'parameter',
                  align: 'center',
                  render: text => <span style={{ color: 'white', fontWeight: 800 }}>{text}</span>,
                },
                {
                  title: 'Value',
                  dataIndex: 'value',
                  key: 'value',
                  align: 'center',
                  render: text => <span style={{ color: 'white', fontWeight: 800 }}>{text}</span>,
                },
              ]}
              dataSource={currentSettingsData}
              bordered
            />
          </div>
          <div className="sidebar-menu__glossary">
            <Table
              style={{
                backgroundColor: 'var(--primary-color)',
              }}
              size="small"
              title={() => (
                <span
                  style={{
                    border: '0',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  Glossary
                </span>
              )}
              pagination={false}
              columns={[
                {
                  title: 'Term',
                  dataIndex: 'parameter',
                  key: 'parameter',
                  align: 'center',
                  render: text => <span style={{ color: 'white', fontWeight: 800 }}>{text}</span>,
                },
                {
                  title: 'Explanation',
                  dataIndex: 'value',
                  key: 'value',
                  align: 'center',
                  render: text => <span style={{ color: 'white', fontWeight: 800 }}>{text}</span>,
                },
              ]}
              dataSource={glossaryData}
              bordered
            />
          </div>
          {
            /**
              (
                <Row gutter={5} style={{ margin: '0px 10px 10px' }}>
                  <Col span={8}>
                    <Button
                      onClick={this.handleExportMapMenuClick}
                      className="sidebar-menu__exportmap"
                      loading={dataStore.loadingExportMaps}
                      type="primary"
                      icon="picture"
                      size="small"
                    >
                      Export Map
                    </Button>
                  </Col>
                  <Col span={8}>
                    <Button
                      onClick={this.handleExportCurves}
                      loading={dataStore.loadingExportCurves}
                      className="sidebar-menu__exportcurves"
                      type="primary"
                      icon="line-chart"
                      size="small"
                    >
                      Export Curves
                    </Button>
                  </Col>
                  <Col span={8}>
                    <Button className="sidebar-menu__usermanual" type="primary" icon="solution" size="small">
                      Manual
                    </Button>
                  </Col>
                </Row>
              )
            */
          }
          <div className="sidebar-menu__liability">
            <h4 className="sidebar-menu__licenseTitle">Bu site "Ege Denizinde Sismik Etkilerle Tsunami Oluşum ve Kıyılardaki Etkilerinin Olasılıksal Analizi, Çevrimiçi Etkileşimli Olasılıksal Tsunami Bilgi Sistemi" başlıklı TUBITAK 121M750 no'lu proje desteği ile hazırlanmıştır. </h4>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default MapMenu;



// WEBPACK FOOTER //
// ./src/components/MapMenu.js